import styled, { css } from 'styled-components'

type GridOptions = {
  orientacao: string
  gridTemplateColumns?: string
  gridTemplateRow?: string
  gridGap: string
  margin?: string
}

const Grid = styled.section<GridOptions>`
  display: grid;
  ${({ orientacao, gridTemplateColumns = '1fr', gridTemplateRow = '1fr', gridGap, margin = '0' }) => css`
    grid-auto-flow: ${orientacao};
    grid-template-columns: ${gridTemplateColumns};
    grid-template-rows: ${gridTemplateRow};
    grid-gap: ${gridGap};
    margin: ${margin};
  `}
`

export default Grid
